<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="true" ref="table" :isAddPageToRouter="true" :isOutside="isOutside">
      <el-table :data='tableData' stripe style="width: 100%">
        <el-table-column prop="chineseName" label="中文名称">
        </el-table-column>
        <el-table-column prop="englishName" label="英文名称">
        </el-table-column>
        <el-table-column prop="category" label="分类" >
          <template slot-scope="scope">
            {{formatDetectionCategory(scope.row.category)}}
          </template>
        </el-table-column>
        <el-table-column prop="tags" label="标签">
          <template slot-scope="scope">
            <el-button type="primary" round  size="mini" v-for="(tag,index) in scope.row.tags" :key="index" style="cursor:default">{{tag}}</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="200">
          <template slot-scope="scope">
           <slot :row="scope.row"></slot>
          </template>
        </el-table-column>
      </el-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
import { formatDetectionCategory } from 'enumeration/lab-order.js'
const prefixCls = 'pt-detection-table'

export default {
  name: 'pt-detection-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    category: {
      type: String,
      default: ''
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDetectionCategory,
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    reload () {
      this.$refs.table.load()
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
